import { OrdnerSection } from "./sections/ordner/OrdnerSection";
import { KundenSection } from "./sections/kunden/KundenSection";
import { SOrdnerSection } from "./sections/sordner/SOrdnerSection";
import { useSettingsAcl } from "./lib/useSettingsAcl";
import { SettingsAccessDenied } from "./SettingsLayout";

export function StammdatenPage() {
  const acl = useSettingsAcl();

  if (acl.loading) return null;
  if (!acl.canAuftraege) return <SettingsAccessDenied />;

  return (
    <div className="space-y-6">
      <OrdnerSection />
      <KundenSection />
      <SOrdnerSection />
    </div>
  );
}
